import { render, staticRenderFns } from "./case_step.vue?vue&type=template&id=386b233a&scoped=true"
import script from "./case_step.vue?vue&type=script&lang=js"
export * from "./case_step.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386b233a",
  null
  
)

export default component.exports